package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ParentNoteReplyResponse(
    val message: String? = null,
    val id: String? = null,
    @SerialName("parent_note_id") val parentNoteId: String? = null,
    @SerialName("sender_id") val senderId: String? = null,
    @SerialName("sender_type") val senderType: String? = null,
    @SerialName("sender_name") val senderName: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String>? = null,
    @SerialName("attachment_file_urls") val attachmentFileUrls: List<String>? = null
)
